// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-group-row[data-v-20b61d6f] {\n  gap: 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  margin-top: 2rem;\n}\n.form-group-row h4[data-v-20b61d6f],\n.form-group-row label[data-v-20b61d6f] {\n  margin-bottom: 0px;\n}\n[type=number][data-v-20b61d6f] {\n  max-width: 100px;\n}", ""]);
// Exports
module.exports = exports;
